import React, { FunctionComponent } from 'react';

import { PaymentFrequency } from 'scenes/common/types';

import SidebarCard from './SidebarCard';
import HeaderCard from './HeaderCard';

type QuotePriceCardProps = {
  sidebarDisplay?: Boolean;
  selectedPaymentFrequency: PaymentFrequency;
  price: string;
  annualPrice: string;
  coverType: string;
  monthlyInstalment: string;
  firstInstalment: string;
  followingMonths: string;
};

const QuotePriceCard: FunctionComponent<QuotePriceCardProps> = ({
  sidebarDisplay,
  selectedPaymentFrequency,
  price,
  annualPrice,
  coverType,
  monthlyInstalment,
  firstInstalment,
  followingMonths,
}) => {
  const premiumAmount =
    selectedPaymentFrequency === PaymentFrequency.Monthly ? price : annualPrice;

  return sidebarDisplay ? (
    <SidebarCard
      paymentFrequency={selectedPaymentFrequency}
      coverType={coverType}
      premiumAmount={premiumAmount}
      instalmentAmount={monthlyInstalment}
      firstInstalment={firstInstalment}
      followingMonths={followingMonths}
    />
  ) : (
    <HeaderCard
      paymentFrequency={selectedPaymentFrequency}
      coverType={coverType}
      premiumAmount={premiumAmount}
      instalmentAmount={monthlyInstalment}
      firstInstalment={firstInstalment}
      followingMonths={followingMonths}
    />
  );
};

export default QuotePriceCard;
